export default __webpack_public_path__ + "static/media/info_03.25b3ada9.png";